function principlesInit() {
  let principlesCards = document.querySelector('.principles__cards');

  const swiper = new Swiper(principlesCards, {
    slidesPerView: 3,
    spaceBetween: 20,

    pagination: {
      el: '.principles__cards .swiper-pagination',
    },

    breakpoints: {
      // when window width is >= 0px
      0: {
        slidesPerView: 1,
        spaceBetween: 14,
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    }
  });
}

export { principlesInit }